import { render, staticRenderFns } from "./professionalExam.vue?vue&type=template&id=0d4ab0ec&"
import script from "./professionalExam.vue?vue&type=script&lang=js&"
export * from "./professionalExam.vue?vue&type=script&lang=js&"
import style0 from "./professionalExam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports